

































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import MediaDownloadImageItem from '../MediaDownload/MediaDownloadImageItem.vue';
import { DownloadImage } from '@/models/DownloadImage';
@Component({
    components: {
        MediaDownloadImageItem
    }
})
export default class LatestMedia extends Vue {
    protected data!: DownloadImage[];
    @Prop() private title!: string;
    @Prop() private linkTitle!: string;
    @Prop() private linkUrl!: string;
    @Prop() private linkTarget!: string;

    constructor() {
        super();
        this.data = JSON.parse(this.$attrs['data-content']);
        this.$attrs['data-content'] = '';
    }
}
